import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Small circular progress indicator on brand tokens (replaced the app's one
 * react-circular-progressbar usage — and its hardcoded celebration green).
 * Sized by its container: the SVG scales to fill (viewBox 0 0 100 100).
 */
export function ProgressRing({
  value,
  label,
  tone = 'primary',
  className,
}: {
  /** 0–100. */
  value: number;
  /** Center text — e.g. "40%" or "✓". */
  label: string;
  tone?: 'primary' | 'success';
  className?: string;
}) {
  const clamped = Math.max(0, Math.min(100, value));
  const r = 44;
  const circumference = 2 * Math.PI * r;
  const color = tone === 'success' ? 'hsl(var(--success))' : 'hsl(var(--primary))';
  return (
    <svg
      viewBox="0 0 100 100"
      className={cn('h-full w-full', className)}
      role="img"
      aria-label={`${Math.round(clamped)}% complete`}
    >
      <circle cx="50" cy="50" r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth="8" />
      <circle
        cx="50"
        cy="50"
        r={r}
        fill="none"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - clamped / 100)}
        transform="rotate(-90 50 50)"
        style={{ transition: 'stroke-dashoffset 0.4s ease' }}
      />
      <text
        x="50"
        y="50"
        dominantBaseline="central"
        textAnchor="middle"
        fill={color}
        style={{ fontSize: '26px', fontWeight: 700 }}
      >
        {label}
      </text>
    </svg>
  );
}
